import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./resources";

export type SupportedLocale = "pt-BR" | "es";
export const LANGUAGE_STORAGE_KEY = "pastejo.language.v1";

function initialLanguage(): SupportedLocale {
  const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (saved === "pt-BR" || saved === "es") return saved;
  return navigator.language.toLowerCase().startsWith("es") ? "es" : "pt-BR";
}

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage(),
  fallbackLng: "pt-BR",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

i18n.on("languageChanged", (language) => {
  const locale: SupportedLocale = language.startsWith("es") ? "es" : "pt-BR";
  localStorage.setItem(LANGUAGE_STORAGE_KEY, locale);
  document.documentElement.lang = locale;
});

document.documentElement.lang = i18n.language;

export const getLocale = (): SupportedLocale => i18n.language.startsWith("es") ? "es" : "pt-BR";
export const translateApiError = (message?: string) => {
  if (!message) return i18n.t("apiErrors.invalidCredentials");
  const normalized = message.trim().toLowerCase();
  if (["credenciais inválidas", "credenciais invalidas", "invalid credentials"].includes(normalized)) {
    return i18n.t("apiErrors.invalidCredentials");
  }
  return message;
};

export default i18n;
